/**
 * PriceChart.jsx
 *
 * Graphique des prix historiques avec Recharts
 */

import React from "react";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Legend,
} from "recharts";
import { Card } from "antd";
import { useTheme } from "../../context/ThemeContext";

/**
 * PriceChart - Affiche l'historique des prix
 */
export default function PriceChart({ offers }) {
    const { isDarkMode } = useTheme();

    const data = offers.map((o) => ({
        date: new Date(o.date).toLocaleDateString("fr-FR"),
        price: Number(o.price),
        devise: o.devise || "$",
    }));

    const colors = {
        lineStroke: isDarkMode ? "#177ddc" : "#1890ff",
        gridStroke: isDarkMode ? "#434343" : "#d9d9d9",
        textColor: isDarkMode ? "#ffffff" : "#000000",
    };

    return (
        <Card style={{ background: isDarkMode ? "#1f1f1f" : "#ffffff" }}>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={data}>
                    <CartesianGrid stroke={colors.gridStroke} />
                    <XAxis
                        dataKey="date"
                        stroke={colors.textColor}
                        style={{ fontSize: "12px" }}
                    />
                    <YAxis
                        stroke={colors.textColor}
                        style={{ fontSize: "12px" }}
                    />
                    <Tooltip
                        contentStyle={{
                            background: isDarkMode ? "#262626" : "#ffffff",
                            border: `1px solid ${colors.gridStroke}`,
                            color: colors.textColor,
                        }}
                    />
                    <Legend />
                    <Line
                        type="monotone"
                        dataKey="price"
                        stroke={colors.lineStroke}
                        strokeWidth={2}
                        dot={{ fill: colors.lineStroke, r: 4 }}
                        activeDot={{ r: 6 }}
                        name="Prix"
                    />
                </LineChart>
            </ResponsiveContainer>
        </Card>
    );
}